import { useContext, useEffect, useState } from "react";
import { BsBook } from "react-icons/bs";
import { Link } from "react-router-dom";
import ProfileAdminDropdown from "../.../../../../utils/dropdowns/ProfileAdminDropdown";
import { firebaseSignOutAdmin } from "../../../../api/admins/adminApi";
import categoriesContext from "../../../../dataManager/context/categoriesContext";
import currentAdminContext from "../../../../dataManager/context/currentAdminContext";
import productsContext from "../../../../dataManager/context/productsContext.js";
import usersContext from "../../../../dataManager/context/usersContext";
import image from "../../../../medias/images/images.jpeg";
import Toogle from "../../../elements/form/Toogle";
import LazyLoadImg from "../../../elements/images/LazyLoadImg";
import Paragraph from "../../../elements/p/Paragraph";
import H2 from "../../../elements/titles/H2";
import Container from "../../../utils/Container";
import LoaderCircle from "../../../utils/LoaderCircle";

const Header = () => {
  //context variables
  const { categories } = useContext(categoriesContext);
  const { products } = useContext(productsContext);
  const { users } = useContext(usersContext);
  const { currentAdmin, logout } = useContext(currentAdminContext);

  //state variables
  const [isToogleOn, setIsToogleOn] = useState(false);

  useEffect(() => {
    console.log(isToogleOn);

    if (isToogleOn) {
      //logout on firebase
      signOutAdmin();

      //set the current user
      logout();
    }
  }, [isToogleOn]);

  //somes functions
  const formatNumber = (num) => (num < 10 ? `0${num}` : num);

  //sigout
  const signOutAdmin = async () => {
    const { data } = await firebaseSignOutAdmin();

    if (data) setIsToogleOn(false);
  };

  return (
    <Container classe="mt-[150px] md:mt-[160px] flex flex-col-reverse md:flex-row items-center justify-between">
      <div className="my-1 mr-2 flex flex-col items-center md:my-0 md:block">
        <H2 classe="text-center md:text-left">
          Interface d'administration de{" "}
          {currentAdmin.getGender
            ? "mr " + currentAdmin.getName.toLowerCase()
            : "madame " + currentAdmin.getName.toLowerCase()}{" "}
          | Statistiques
        </H2>
        <div className="mt-5 flex flex-col items-center space-y-3 sm:flex-row sm:space-y-0 sm:space-x-3 lg:space-x-5">
          <Stat
            numberStat={100}
            titleStat="Catégories de produits"
            data={categories}
          />
          <Stat
            numberStat={formatNumber(8)}
            titleStat="Produits publiés"
            data={products}
          />
          <Stat
            numberStat={22}
            titleStat="Utilisateurs non contactés"
            data={users}
          />
        </div>
      </div>

      <div className="flex flex-col-reverse items-center space-x-3 md:flex-row">
        <div className="my-5 flex flex-col space-y-1.5 text-center md:my-0 md:text-left">
          <Paragraph size="small" classe="text-secondary/90">
            {currentAdmin ? currentAdmin.getName : "Francis"}
          </Paragraph>

          <Paragraph size="small" classe="text-secondary/90">
            {currentAdmin ? currentAdmin.getEmail : ""}
          </Paragraph>

          <Paragraph size="small" classe="text-secondary/90">
            {currentAdmin ? currentAdmin.getPhone : ""}
          </Paragraph>
          <div className="flex items-center space-x-2 md:flex-col md:items-start md:space-x-0 md:space-y-2">
            <ProfileAdminDropdown />
            <Link
              to="/documentation"
              target="_blank"
              className="flex items-center justify-center space-x-1 rounded-full border-2 border-primary p-1 px-5 text-center font-nunito text-sm text-primary md:px-2 lg:px-5"
            >
              <span>documentation</span>
              <BsBook className="md:hidden lg:block" />
            </Link>
          </div>
        </div>
        <div className="flex flex-col items-center">
          <LazyLoadImg
            img={currentAdmin ? currentAdmin.getImage : image}
            alt="Monsieur francis"
            classe="rounded-full w-32 md:w-52 block"
          />
          <div
            title="se déconnecter"
            className="mt-3 flex h-[30px] items-center space-x-2 text-center font-nunito text-xs text-primary md:text-sm"
          >
            <span>Déconnexion</span>
            <Toogle isToogleOn={isToogleOn} setisToogleOn={setIsToogleOn} />
          </div>
        </div>
      </div>
    </Container>
  );
};

const Stat = ({ titleStat, data }) => {
  //somes functions
  const formatNumber = (num) => (num < 10 ? `0${num}` : num);

  return (
    <div class="border-gray-100 group flex flex-col rounded-lg border px-4 py-8 text-center hover:bg-primary">
      <dt class="order-last font-nunito text-base font-medium text-secondary group-hover:text-smoot md:text-lg">
        {titleStat}
      </dt>

      {data.length ? (
        <dd class="font-nunito text-4xl font-extrabold text-primary group-hover:text-white md:text-5xl">
          {formatNumber(data.length)}
        </dd>
      ) : (
        <LoaderCircle />
      )}
    </div>
  );
};

export default Header;
